module.exports = __webpack_public_path__ + "img/aimPoint2.14676192.png";